import { ApiService } from 'services';
// import { handleException } from 'actions/exceptions';

export const GET_LANGUAGE_REQUEST = 'GET_LANGUAGE_REQUEST';
export const GET_LANGUAGE_FAILURE = 'GET_LANGUAGE_FAILURE';
export const GET_LANGUAGE_SUCCESS = 'GET_LANGUAGE_SUCCESS';
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

function request() {
  return {
    type: GET_LANGUAGE_REQUEST,
  };
}

function receive(locale, messages) {
  return {
    type: GET_LANGUAGE_SUCCESS,
    locale,
    messages
  };
}

function changeLocale(locale) {
  return {
    type: CHANGE_LOCALE,
    locale
  };
}

export function getLanguage(locale) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getLanguage(locale)
      .then((response) => {
        dispatch(receive(locale, response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(changeLocale('en'));
        }
      });

    return promise();
  };
}
